import matchText from '@/utils/match-text';

/**
 * @mixin encapsulates split button common functionality
 */
export default {
	data() {
		return {
			searchTextData: ''
		};
	},
	props: {
		searchable: {
			type: Boolean,
			default: false
		},
		hasMoreSearchListOptions: {
			type: Boolean,
			default: false
		},
		searchText: {
			type: String,
			default: undefined
		}
	},
	watch: {
		searchText: {
			immediate: true,
			handler(val) {
				this.searchTextData = val;
			}
		}
	},
	methods: {
		getMatchText(text) {
			let optText = text;
			let isMatch = text != null;

			if (optText && this.searchable && this.searchTextData) {
				const matchResult = matchText(text, this.searchTextData);

				isMatch = matchResult.success;

				if (isMatch) {
					optText = matchResult.formattedText;
				}
			}

			return { optText, isMatch };
		}
	},
	computed: {
		matchOptions() {
			let optText;
			let optSubText;
			let opts = [];
			this.options.forEach(opt => {
				const matchResult = this.getMatchText(opt.text);
				const subTextMatchResult = this.getMatchText(opt.subText);

				optText = matchResult.optText;
				optSubText = subTextMatchResult.optText;

				if (matchResult.isMatch || subTextMatchResult.isMatch) {
					opts.push({
						text: optText,
						subText: optSubText,
						value: opt.value,
						disabled: opt.disabled
					});
				}
			});

			return opts;
		}
	}
};
